module.exports = __webpack_public_path__ + "img/MeterWorkOrders-Field_lg.a6f00847.png";